import { getTouchPointNotifications } from 'src/touchpoint-notifications/get-touchpoint-notifications';
import { checkAndGetArray } from '../../common/helpers/array-helper';
import { IReceipt } from '../../common/interfaces/dtos/IReceipt';
import { CashOfficeMenuState } from '../../common/interfaces/states/CashOfficeMenuState';
import { store } from '../../common/redux/configure-store';
import { printReceipts } from '../../devices/printer-operations';
import { popupMessage } from '../../messages/business-logic/popup-message';
import { closeDrawer } from '../components/cash-drawer-actions';
import { AmountAndTender, PaidActionRequest } from '../interfaces/PaidActionRequest';
import { postPaidOut } from './services/post-paid-out';

export const processPaidOut = async (
  tenderMenuGroups: Partial<CashOfficeMenuState>,
  accountId: string,
): Promise<void> => {
  const paidOutRequest: PaidActionRequest = {
    source: store.getState().touchPoint.touchPointConfiguration.accountExternalId ?? '',
    destination: accountId,
    amountAndTender: createAmountAndTenderList(tenderMenuGroups),
    taxable: false,
  };
  await postPaidOut(paidOutRequest)
    .then(
      async (receipts: IReceipt[]): Promise<void> => {
        if (receipts && receipts.length > 0) {
          await printReceipts(checkAndGetArray(receipts)).catch(popupMessage);
        }
        closeDrawer();
        await getTouchPointNotifications();
      },
    )
    .catch(err => {
      popupMessage(err);
    });
};

const createAmountAndTenderList = (
  tenderMenuGroups: Partial<CashOfficeMenuState>,
): AmountAndTender[] => {
  const tenderPickupRequestList: AmountAndTender[] = [];
  if (tenderMenuGroups.sellableTenders && tenderMenuGroups.sellableTenders?.tenderGroups) {
    return tenderMenuGroups.sellableTenders?.tenderGroups.flatMap(tenderGroup => {
      const tenderList = tenderGroup.tenderCountList || [];
      return tenderList.map(tenderCountEntry => ({
        amount: tenderCountEntry.amount,
        tender: tenderCountEntry.id,
      }));
    });
  }

  return tenderPickupRequestList;
};
